var exports = {
  "pz": "sidebar__B0iMaS",
  "_C": "bodyScrollable__quRUTi",
  "U0": "condensed__uQxui0",
  "zE": "expandedSmall__8EMnas",
  "HU": "expandedMedium__u13fz8",
  "Ho": "expandedLarge__enSEGb",
  "Ig": "resizable__hrX-NQ",
  "vv": "toggleList__Vql32P",
  "qr": "footer__i7NWzN",
  "Xt": "footerStructural__H88_1t",
  "$7": "sentinel__Hx_86S",
  "Qx": "footerClipping__tPU9KH",
};

module.exports = exports;
